import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-generic-list-input',
  templateUrl: './generic-list-input.component.html',
  styleUrls: ['./generic-list-input.component.scss']
})
export class GenericListInputComponent {
  @Input() testingId = null;
  @Input() data: any;
  @Input() type: 'text' | 'number' | 'time';
  @Input() suffix = '';
  @Input() controlName: string;
}
